/**
 * SummaryCardsRow Component
 * Horizontal flex row that wraps SummaryCard instances.
 */

import { ReactNode } from 'react';
import styled from 'styled-components';

export interface SummaryCardsRowProps {
  children: ReactNode;
}

const Row = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing[4]};
  flex-wrap: wrap;
`;

export function SummaryCardsRow({ children }: SummaryCardsRowProps) {
  return <Row>{children}</Row>;
}

export default SummaryCardsRow;
